export const toCurrency = function (value) {
    return Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        // minimumFractionDigits: 0,
        // maximumFractionDigits: 2
    }).format(+value).replace(',00', '')
}
